module.exports = __webpack_public_path__ + "img/horizontal_7_7_6000.d7bf1591.png";